// extracted by mini-css-extract-plugin
module.exports = {"header":"header__tvZhV","header-name":"header-name__2fiUG"};